import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/sharp-light-svg-icons";
import { useState } from "react";
import { Sidepanel } from "../../../../ui/Sidepanel";
import { useEmissionEventData } from "../../../EventsV2/eventData";
import { FormV2 } from "./FormV2";

interface EmissionFormSidePanelProps {
    emissionId: string;
    onClose: () => void;
}

export const EmissionFormSidePanel = (props: EmissionFormSidePanelProps) => {
    const [formKey, setFormKey] = useState(0);

    const {
        isLoading,
        addFormToEventMutation,
        removeFormFromEventMutation,
        availableForms,
        company,
        emissionData,
        eventForms,
    } = useEmissionEventData(props.emissionId);

    const handleSaved = () => setFormKey((k) => k + 1);

    return (
        <Sidepanel>
            {isLoading ? (
                <div className="w-full h-full flex items-center justify-center">
                    <FontAwesomeIcon
                        icon={faSpinner}
                        className="w-8 h-8 animate-spin"
                    />
                </div>
            ) : (
                <FormV2
                    key={formKey}
                    addFormToEventMutation={addFormToEventMutation}
                    removeFormFromEventMutation={removeFormFromEventMutation}
                    availableForms={availableForms}
                    emissionData={emissionData}
                    eventForms={eventForms}
                    onClose={props.onClose}
                    onSaved={handleSaved}
                    company={company}
                />
            )}
        </Sidepanel>
    );
};
